import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Chef from "./components/Chef";
import Menu from "./components/Menu";
import Experience from "./components/Experience";
import WhereItBelongs from "./components/WhereItBelongs";
import Footer from "./components/Footer";
import ChefGallery from "./components/ChefGallery";

const Home = () => {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <About />
        <Chef />
        <Menu />
        <Experience />
        <WhereItBelongs />
      </main>
      <Footer />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/chef-gallery" element={<ChefGallery />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
